import { Component, Input } from "@angular/core";

@Component({
  selector: "ab-external-link",
  templateUrl: "./external-link.component.html",
})
export class ExternalLinkComponent {
  @Input() public href: string;
}
